import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Tab, Tabs } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import RefreshIcon from "@material-ui/icons/Refresh";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Link as RouterLink } from "react-router-dom";

import MainContainer from "../../components/MainContainer";
import { EmptyState, PageHeader, Section } from "../../components/ui";
import { i18n } from "../../translate/i18n";
import { getTokens } from "../../styles/tokens";
import useHotspotStatus from "../../hooks/useHotspotStatus";

import VoucherBatchesTab from "./VoucherBatchesTab";
import DevicesTab from "./DevicesTab";
import PaymentsTab from "./PaymentsTab";
import SummaryTab from "./SummaryTab";

const TAB_VOUCHERS = 0;
const TAB_DEVICES = 1;
const TAB_PAYMENTS = 2;
const TAB_SUMMARY = 3;

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    // o sublinhado da aba ativa assenta sobre o filete
    tabs: {
      flex: "none",
      marginBottom: 16,
      borderBottom: `1px solid ${t.line}`,
    },
    tab: { minWidth: 0, padding: "8px 16px" },
    // cada aba rola inteira: os cartões de resumo não espremem a tabela em telas baixas
    tabBody: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      paddingBottom: 16,
      ...theme.scrollbarStyles,
      "& > *": { flex: "none" },
    },
    skeleton: { borderRadius: t.radius.md },
  };
});

const Hotspot = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(TAB_VOUCHERS);
  const { enabled, loading, error, refresh } = useHotspotStatus();

  return (
    <MainContainer maxWidth>
      <PageHeader title={i18n.t("hotspot.title")} subtitle={i18n.t("hotspot.subtitle")} />

      {loading ? (
        <Skeleton variant="rect" height={220} className={classes.skeleton} aria-busy="true" />
      ) : !enabled && error ? (
        <Section>
          <EmptyState
            icon={<ErrorOutlineIcon />}
            title={i18n.t("hotspot.unavailable.title")}
            message={i18n.t("hotspot.unavailable.text")}
            action={
              <Button variant="outlined" startIcon={<RefreshIcon />} onClick={() => refresh()}>
                {i18n.t("hotspot.unavailable.action")}
              </Button>
            }
          />
        </Section>
      ) : !enabled ? (
        <Section>
          <EmptyState
            icon={<SettingsEthernetIcon />}
            title={i18n.t("hotspot.notConfigured.title")}
            message={i18n.t("hotspot.notConfigured.text")}
            action={
              <Button component={RouterLink} to="/queue-integration" variant="contained" color="primary">
                {i18n.t("hotspot.notConfigured.action")}
              </Button>
            }
          />
        </Section>
      ) : (
        <>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            className={classes.tabs}
            variant="scrollable"
            scrollButtons="off"
            aria-label={i18n.t("hotspot.title")}
          >
            <Tab className={classes.tab} label={i18n.t("hotspot.tabs.vouchers")} />
            <Tab className={classes.tab} label={i18n.t("hotspot.tabs.devices")} />
            <Tab className={classes.tab} label={i18n.t("hotspot.tabs.payments")} />
            <Tab className={classes.tab} label={i18n.t("hotspot.tabs.summary")} />
          </Tabs>

          <div className={classes.tabBody}>
            {tab === TAB_VOUCHERS && <VoucherBatchesTab />}
            {tab === TAB_DEVICES && <DevicesTab />}
            {tab === TAB_PAYMENTS && <PaymentsTab />}
            {tab === TAB_SUMMARY && <SummaryTab />}
          </div>
        </>
      )}
    </MainContainer>
  );
};

export default Hotspot;
